import { read } from 'gso-session';
import { Locale } from './types';
function userLanguage() {
    return read('user') ? read('user').language : navigatorLanguage();
}
function navigatorLanguage() {
    var locale = window.navigator.userLanguage || window.navigator.language;
    locale = /..-../.test(locale) ? locale.split('-')[0] : locale.split('_')[0];
    if (['en', 'fr', 'nl'].includes(locale)) {
        const typedLocale = locale;
        return Locale[typedLocale];
    }
    return Locale.en;
}
export default userLanguage;
//# sourceMappingURL=user-language.js.map